import { sharedSchema } from "@shared-database/pgSchema";
import { leoID, timestampColumns } from "@shared-database/utils";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";
import {
  index,
  integer,
  text,
  unique,
  type AnyPgColumn,
} from "drizzle-orm/pg-core";

export const Department = sharedSchema.table(
  "Department",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    id: leoID("id"),
    name: text("name").notNull(),
    level: integer("level").notNull(),
    parentId: text("parentId").references((): AnyPgColumn => Department.id),
  },
  (table) => [
    unique().on(table.name, table.level, table.parentId),
    index().on(table.parentId),
    index().on(table.name),
  ],
);

export type DepartmentInsertType = InferInsertModel<typeof Department>;
export type DepartmentBlueprint = Omit<DepartmentInsertType, "id"> & {
  id: string;
};
export type DepartmentSelectType = InferSelectModel<typeof Department>;
